<label
  class="checkbox is-flex is-align-items-center mr-2 content is-small pl-0"
>
  <input
    type="checkbox"
    class="mr-1"
    id="favorite-button"
    (click)="toggleFavorite(incentive)"
    [checked]="isFavorite"
    [attr.data-tooltip]="tooltipContent"
    [ngClass]="{
      'has-tooltip-hidden-tablet  has-tooltip-right has-tooltip-hidden-mobile':
        compact
    }"
  />
  <span *ngIf="!compact">Add to comparison</span>
</label>
